export default __webpack_public_path__ + "images/G6.c667832.png";